export interface EnquiryCreateResponse {
  success?: boolean;
  duplicate?: boolean;
  data?: unknown;
}

export function isDuplicateEnquiryResponse(
  response: EnquiryCreateResponse | null | undefined,
): boolean {
  return response?.duplicate === true;
}
